import { Component, EventEmitter, Input, Output, ViewEncapsulation, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'tidy-popup-overlay',
  templateUrl: './popup-overlay.component.html',
  styleUrls: ['./popup-overlay.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PopupOverlayComponent implements AfterViewInit, OnDestroy {
  @ViewChild('contentEl') contentEl!: ElementRef<HTMLElement>;
  @Input() closeOnBackdropClick = true;
  @Input() isOpen = false;
  @Input() maxHeight = '85vh';
  @Input() maxWidth = '420px';
  @Input() position: 'center' | 'bottom' = 'center';
  @Input() showCloseButton = true;
  @Input() swipeToDismiss = true;
  @Input() title = '';
  @Output() closed = new EventEmitter<void>();

  dragOffset = 0;
  isDragging = false;
  private startY = 0;
  private currentY = 0;
  private dismissThreshold = 100;

  ngAfterViewInit(): void {
    // Lifecycle hook required for ViewChild
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.closed.emit();
    }
  }

  onCloseClick(): void {
    this.closed.emit();
  }

  onContentClick(event: Event): void {
    event.stopPropagation();
  }

  onTouchStart(event: TouchEvent): void {
    if (this.position !== 'bottom' || !this.swipeToDismiss) {
      return;
    }
    this.isDragging = true;
    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;
  }

  onTouchMove(event: TouchEvent): void {
    if (!this.isDragging) {
      return;
    }
    this.currentY = event.touches[0].clientY;
    const diff = this.currentY - this.startY;
    this.dragOffset = Math.max(0, diff);
  }

  onTouchEnd(): void {
    if (!this.isDragging) {
      return;
    }
    this.isDragging = false;
    if (this.dragOffset > this.dismissThreshold) {
      this.closed.emit();
    }
    this.dragOffset = 0;
  }

  getContentTransform(): string {
    if (this.dragOffset > 0) {
      return `translateY(${this.dragOffset}px)`;
    }
    return '';
  }

  getContentOpacity(): number {
    if (this.dragOffset > 0) {
      return Math.max(0.5, 1 - (this.dragOffset / (this.dismissThreshold * 2)));
    }
    return 1;
  }
}
